var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_848_8855",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6616 0.0729096L0.482874 8.42195C0.329139 8.46548 0.196207 8.56352 0.108578 8.69799C0.0209495 8.83247 -0.0154709 8.99431 0.00602932 9.15369C0.0275296 9.31308 0.105501 9.45927 0.225575 9.56532C0.345649 9.67136 0.499731 9.73012 0.659426 9.73076L19.4922 9.59917C19.9026 9.59515 20.3098 9.67341 20.6899 9.82939C21.07 9.98537 21.4156 10.2159 21.7064 10.5077C21.9972 10.7995 22.2275 11.1466 22.3839 11.5288C22.5402 11.9111 22.6195 12.3209 22.6172 12.7343L22.5254 29.1425C22.5267 29.3043 22.5863 29.4601 22.6932 29.5808C22.8001 29.7016 22.947 29.7791 23.1064 29.7989C23.2658 29.8187 23.4269 29.7795 23.5598 29.6885C23.6926 29.5975 23.788 29.4609 23.8283 29.3043L31.9391 2.32777C32.0107 2.05451 32.0193 1.76839 31.9643 1.49125C31.9093 1.21412 31.7922 0.953308 31.6219 0.728731C31.4515 0.504153 31.2325 0.321752 30.9815 0.195454C30.7305 0.0691565 30.4541 0.00230347 30.1736 0C30.001 0.000418813 29.8293 0.0249559 29.6633 0.0729096",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_848_8855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2565 0H-0.259064V30.0565H32.2565V0Z",
    fill: "url(#paint0_linear_848_8855)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_848_8855",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 13,
    width: 11,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1481 20.9219C10.6325 20.4154 10.3076 19.7442 10.2289 19.0231C10.1502 18.302 10.3227 17.5758 10.7169 16.9686C11.111 16.3614 11.7024 15.911 12.3897 15.6943C13.0771 15.4777 13.8179 15.5083 14.4853 15.7809C15.1528 16.0536 15.7055 16.5512 16.0489 17.1889C16.3924 17.8266 16.5052 18.5646 16.3682 19.2768C16.2311 19.989 15.8527 20.6312 15.2976 21.0934C14.7425 21.5557 14.0452 21.8094 13.325 21.8111C12.5118 21.813 11.7303 21.4938 11.1481 20.9219ZM17.4828 13.9262L9.08069 14.0044C9.01609 14.0049 8.95221 14.0182 8.89273 14.0436C8.83324 14.069 8.77931 14.1059 8.73404 14.1524C8.68877 14.1988 8.65304 14.2538 8.62891 14.3141C8.60478 14.3745 8.59271 14.4391 8.59341 14.5041L8.6711 22.967C8.67179 23.0319 8.68517 23.096 8.71048 23.1557C8.73578 23.2155 8.77252 23.2696 8.81859 23.315C8.86466 23.3604 8.91916 23.3962 8.97897 23.4204C9.03879 23.4446 9.10275 23.4567 9.1672 23.456L17.5693 23.3777C17.6338 23.3768 17.6974 23.3631 17.7566 23.3374C17.8158 23.3117 17.8694 23.2745 17.9143 23.2279C17.9592 23.1814 17.9946 23.1263 18.0184 23.066C18.0422 23.0057 18.054 22.9412 18.0531 22.8763L17.9754 14.4134C17.9744 14.2829 17.9223 14.1581 17.8304 14.0662C17.7384 13.9742 17.6141 13.9226 17.4846 13.9226",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_848_8855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0611 13.9226H8.59259V23.456H18.0611V13.9226Z",
    fill: "url(#paint1_linear_848_8855)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_848_8855",
    x1: -0.259064,
    y1: 15.0283,
    x2: 32.2565,
    y2: 15.0283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_848_8855",
    x1: 8.59259,
    y1: 18.6893,
    x2: 18.0611,
    y2: 18.6893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06BCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/LogoMark.09622d9532adf6027375605a8407657b.svg";
export { ForwardRef as ReactComponent };